import { useMemo } from "react";
import { Money } from "@/utils/money";

export const useNormalizedPrice = ({ period, price }) => {
  const priceList = price?.price?.month;
  const currency = price?.currency;
  const normalized = useMemo(() => {
    if (!priceList || !currency || !period) return null;
    const activePrice = priceList[period];
    if (!activePrice) return null;
    const money = { currency, amount: activePrice.final };
    const hasDiscount = activePrice.discount;
    let perMonthInitial = {
      currency,
      amount: priceList[1].final,
    };
    if (priceList[1].discount) {
      perMonthInitial = Money.addScalar(perMonthInitial, priceList[1].discount);
    }
    const perMonthFinal = Money.divByScalar(money, period);
    return {
      final: money,
      initial: hasDiscount
        ? Money.addScalar(money, activePrice.discount)
        : money,
      perMonthFinal,
      perMonthInitial,
      perDayFinal: Money.divByScalar(perMonthFinal, 30),
      perDayInitial: Money.divByScalar(perMonthInitial, 30),
    };
  }, [period, priceList, currency]);
  return normalized;
};
